import axios from 'axios';
import { sessionManager } from '../auth/sessionManager';
import {
  API_BASE_URL,
  VITE_AUTH_USER_NAME,
  VITE_AUTH_ACCESS_TOKEN,
} from '../environment';
import {
  API,
  DEVICE_WATERPURIFIER_ENDPOINT,
  HUMIDIFIER_STATE_API_CONFIG,
  KIMCHI_REFERIGERATOR_STATE_API_CONFIG,
  SHOEDRESSER_STATE_API_CONFIG,
  STEAMCLOSET_STATE_API_CONFIG,
  WSAHER_DRYER_STATE_API_CONFIG,
} from './api';
import { client } from './client';

// Function to fetch token from external API
// Uses fetch with credentials: 'omit' to ensure no cookies are sent with this request
// NOTE: This function will return null if credentials are not configured (for production environments)
export const fetchAccessToken = async () => {
  // Check if credentials are configured - skip API call if not set (local testing only)
  if (!VITE_AUTH_USER_NAME || !VITE_AUTH_ACCESS_TOKEN) {
    return null;
  }

  const params = new URLSearchParams({
    grant_type: 'password',
    username: 'credentials',
    password: VITE_AUTH_USER_NAME,
  });

  const response = await fetch(
    `${API_BASE_URL}${API.AUTH_ENDPOINT}?${params.toString()}`,
    {
      method: 'POST',
      headers: {
        UserAuthorization: 'partner',
        Authorization: `Basic ${VITE_AUTH_ACCESS_TOKEN}`,
        'Content-Type': 'application/json',
      },
      // credentials: 'omit' ensures no cookies are sent with this request
      credentials: 'omit',
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch access token: ${response.status}`);
  }

  return response.json();
};

export const postMultiDevicesInformation = async payload => {
  const response = await client.post(API.MULTI_DEVICES_INFORMATION, payload, {
    skipLoader: true,
  });
  return response.data;
};

export const saveMultiDeviceData = async payload => {
  const response = await client.post(API.MULTI_DEVICES_SAVE_DATA, payload, {
    skipLoader: true,
  });
  return response.data;
};

export const getDeviceInformation = deviceId =>
  client.get(API.DEVICES_INFORMATION(deviceId), {
    skipLoader: true,
  });

export const postServiceInformation = async payload => {
  const response = await client.post(
    API.SERVICE_INFORMATION(payload.svcId),
    payload,
    {
      skipLoader: true,
    }
  );
  return response.data;
};

export const updateServiceInformation = async payload => {
  const response = await client.post(
    API.SERVICE_INFORMATION_UPDATE(payload.svcId),
    payload
  );
  return response.data;
};

export const getDeviceTypeUisngPinCode = async (deviceType, pincode,svcId) => {
  console.log("insider");
  const response = await client.get(API.GET_DEVICE_TYPE(deviceType, pincode),{
    params:{svcId}
  });
  return response.data;
};

export const getDeviceErrorHistory = devceId =>
  client.get(API.DEVICE_ERROR_HISTORY(devceId), {
    skipLoader: true,
  });

export const getDeviceOperationHistory = devceId =>
  client.get(API.DEVICE_OPERATION_HISTORY(devceId), {
    skipLoader: true,
  });

export const getServiceInformationEndtype = params =>
  client.get(API.SERVICE_INFORMATION_ENDTYPE, { params: params });

export const saveData = async payload => {
  const response = await client.post(API.SAVE_DATA, payload, {
    skipLoader: true,
  });
  return response.data;
};

export const postSVCResult = payload => {
  const svcId = payload.serviceInfo.svcId;
  return client.post(API.SAVE_RESULT_APIENDPOINT(svcId), payload);
};

export const postUpdateSvcEzoneHistory = async payload => {
  const response = await client.post(API.UPDATE_SVC_HISTORY, payload);
  return response.data;
};

export const getServiceInformation = svcId => {
  return client.get(API.SERVICE_INFORMATION(svcId), {
    skipLoader: true,
  });
};

export const postDevicermstate = ({ uuid, saUid, payload }) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };

  return client.post(API.POST_DEVICE_RM_STATE(uuid), payload, { headers });
};

export const postDevicermstateForced = (uuid, deviceType, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
    'Content-Type': 'application/json',
  };
  return client.post(
    API.POST_DEVICE_RM_STATE_PINCODE_FORCED(uuid, deviceType),
    null,
    { headers }
  );
};

//device apiservice

export const getDeviceAnalyticSymptom = (deviceUUID, queryParams) => {
  return client.get(API.DEVICE_ANALYTICS_SYMPTOM(deviceUUID), {
    params: queryParams,
    skipLoader: true,
  });
};

export const getDeviceErrorSymptom = (deviceUUID, queryParams) => {
  return client.get(API.DEVICE_ERROR_SYMPTOM(deviceUUID), {
    params: queryParams,
    skipLoader: true,
  });
};

export const getDeviceAnalyticSummary = deviceUUID => {
  return client.get(API.DEVICE_ANALYTICS_SUMMARY(deviceUUID), {
    skipLoader: true,
    skipErrorNotification: true,
  });
};

export const deviceAnalysticsFeedback = payload => {
  const deviceUUID = payload['di'];
  return client.post(API.DEVICE_ANALYTICS_FEEDBACK(deviceUUID), payload, {
    skipLoader: true,
  });
};

export const postScreenshotStart = payload => {
  const headers = {
    'X-User-Id': payload?.saUid,
    'X-Request-Id': 'random',
  };

  return client.post(API.SCREENSHOT_START, payload.data, { headers });
};

export const getDeviceStates = deviceUUID => {
  return client.get(API.DEVICE_STATES(deviceUUID), {
    skipLoader: true,
  });
};
export const getDevicesUisngPinCode = (deviceType, pincode, svcId) => {
  return client.get(API.GET_DEVICE_LIST_USING_PINCODE(deviceType, pincode), {
    params: { svcId },
  });
};
export const updateDeviceRefrigeration = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateDeviceServiceOption = (
  deviceUUID,
  option,
  payload,
  saUid
) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};
export const updateDeviceTemperature = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateDeviceTemperatureCubeRef = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateWineCellarTemperature = (
  deviceUUID,
  unitId,
  payload,
  saUid
) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateIceMakerOne = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateForceDefrost = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateDefrost = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateSmartReset = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

// New smart reset API for wine cellar
export const updateWineCellarSmartReset = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateIceMakerReset = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};
export const updateVacation = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateIceMakerTwo = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateIceMakerThree = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateNightIceMaking = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateSpecialZoneBeverage = (
  deviceUUID,
  zoneId,
  payload,
  saUid
) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateIceMaker = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateMode = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_MODE(deviceUUID), payload, {
    headers,
  });
};

export const updateAutoFill = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateFiltersReset = (deviceUUID, filterId, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_FILTERS_RESET(deviceUUID, filterId), payload, {
    headers,
  });
};

export const updateDispenser = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

export const updateModeOptions = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_MODE_OPTIONS(deviceUUID), payload, {
    headers,
  });
};

export const updateLock = (deviceUUID, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.DEVICE_CONTROL_ENDPOINT(deviceUUID), payload, {
    headers,
  });
};

// FHub API
export const updateFhub = (deviceId, payload, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };
  return client.post(API.UPDATE_FHUB(deviceId), payload, { headers });
};

export const getScreenShareImage = async (url, key) => {
  const res = await axios.get(url, {
    headers: {
      'x-api-key': key,
    },
  });
  return res;
};
export const postRCDiagnosis = (deviceId, payload) => {
  return client.post(API.DEVICE_RC_DIAGNOSIS(deviceId), payload);
};
// Device map history
export const getDeviceMapHistory = (deviceId, queryParams) => {
  return client.get(API.DEVICE_MAP_HISTORY(deviceId), {
    params: queryParams,
    skipLoader: true,
  });
};

//washer state upadte
const getHeader = saUid => {
  return {
    'Content-Type': 'application/json',
    'X-User-Id': saUid,
    'X-Request-Id': 'rendom',
  };
};
export const handleRemoteControl = (di, payload, saUid) => {
  const headers = getHeader(saUid);
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, { headers });
};
export const updateWasherDryerState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = WSAHER_DRYER_STATE_API_CONFIG[param];
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};

export const updateDishwasherState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = '/dishwasher';
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};

export const updateSteamClosetState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = STEAMCLOSET_STATE_API_CONFIG[param];
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};
export const updateWaterpurifierState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = DEVICE_WATERPURIFIER_ENDPOINT[param];
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};

export const updateShoeDresserState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = SHOEDRESSER_STATE_API_CONFIG[param];
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};

export const updateHumidifierState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = HUMIDIFIER_STATE_API_CONFIG[param];
  return client.post(API.STATE_UPDATE(di, endpoint), payload, {
    headers,
  });
};
const modeKeys = [
  'mode.modes',
  'options.Blooming',
  'options.Volume',
  'options.OnTimer',
  'options.OffTimer',
  'options.Autoclean',
  'options.Display',
  'options.Booster',
  'options.ComfortAICooling',
  'options.DiagnosisAI',
  'options.SmartCoolClean',
];

const modeConvenientKeys = ['comode.comode'];
const modeOptionsKeys = ['options.Sleep', 'options.Light', 'options.Panel'];

export const updateAirconditionerState = (
  param,
  payload,
  saUid,
  di,
  unitId
) => {
  const headers = getHeader(saUid);

  const unitSuffix1 = unitId || unitId === 0 ? unitId : '';
  const unitSuffix2 = unitId && Number(unitId) > 0 ? unitId : '';

  let updatedPayload = {
    ...payload,
    unitId: unitSuffix1 ? unitSuffix1 : unitSuffix2 ? unitSuffix2 : 0,
    ...([...modeKeys, ...modeConvenientKeys, ...modeOptionsKeys].includes(param)
      ? {
          convenient: modeConvenientKeys.includes(param) ? true : false,
          modeType: modeOptionsKeys.includes(param) ? 'options' : 'mode',
        }
      : {}),
  };
  console.log(updatedPayload);
  if (param.startsWith('airconditioner') && payload.options) {
    return client.post(API.DEVICE_CONTROL_ENDPOINT(di), updatedPayload, {
      headers,
    });
  }

  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), updatedPayload, {
    headers,
  });
};

export const updateKimchiRefrigeratorState = (param, payload, saUid, di) => {
  const headers = getHeader(saUid);
  const endpoint = KIMCHI_REFERIGERATOR_STATE_API_CONFIG[param];
  return client.post(API.DEVICE_CONTROL_ENDPOINT(di), payload, {
    headers,
  });
};

/**
 * Save data using fetch with keepalive (for beforeunload)
 * Guarantees delivery even after page closes
 */
export const saveDataWithKeepalive = payload => {
  const token = sessionManager.getToken();
  return fetch(`${API_BASE_URL}${API.SAVE_DATA}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    keepalive: true,
  });
};

/**
 * Post SVC result using fetch with keepalive (for beforeunload)
 * Guarantees delivery even after page closes
 */
export const postSVCResultWithKeepalive = payload => {
  const token = sessionManager.getToken();
  const svcId = payload.serviceInfo.svcId;
  return fetch(`${API_BASE_URL}${API.SAVE_RESULT_APIENDPOINT(svcId)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    keepalive: true,
  });
};

/**
 * Post device RM state using fetch with keepalive (for beforeunload)
 * Guarantees delivery even after page closes
 * Includes custom headers: X-User-Id, X-Request-Id
 */
export const postDevicermstateWithKeepalive = ({ uuid, saUid, payload }) => {
  const token = sessionManager.getToken();
  return fetch(`${API_BASE_URL}${API.POST_DEVICE_RM_STATE(uuid)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-User-Id': saUid,
      'X-Request-Id': 'random',
    },
    body: JSON.stringify(payload),
    keepalive: true,
  });
};

/**
 * Post SmartThings link (noise/image) to device
 * @param {string} deviceUuid - Device UUID
 * @param {string} type - Link type: "noise" or "image"
 * @param {string} saUid - Service agent user ID
 * @returns {Promise} Axios promise
 */
export const postSmartThingsLink = (deviceUuid, type, saUid) => {
  const headers = {
    'X-User-Id': saUid,
    'X-Request-Id': 'random',
  };

  const payload = {
    type: type,
    device_id: deviceUuid,
  };

  return client.post(API.SMARTTHINGS_LINK, payload, { headers });
};
